import React from 'react';
import PreDeliveringContainer from './PreDeliveringContainer';

const Shopee = (props) => (
  <PreDeliveringContainer
    createdSource="shopee"
    title="Shopee Pre-Delivering List"
    {...props}
  />
);

export default Shopee;
